export const TRANSLATE_EN = {
  // landingPage: {
  //   accueil: 'HOME',
  //   produits: 'PRODUCTS',
  //   solutions: 'SOLUTIONS',
  //   api: 'API',
  //   token: 'TOKEN',
  //   plateform: 'PLATFORM',
  //   tarif: 'TARIFF',
  //   reference: 'REFERENCE',
  //   propos: 'ABOUT',
  //   fr: 'EN',
  //   espaceClient: 'CUSTOMER SPACE',
  //   connexion: 'SIGN IN',
  //   inscrivezVous: 'SUBSCRIBE TO THE NEWSLETTER',
  //   descriptionFooter: `DKBSign is a platform made available to users to allow them to make electronic signature in order to give legal value to signed documents. DKBSign is a product of DKB Trusted Third Party Solutions approved by ARTCI, committed to ensuring the security, confidentiality, integrity of transactions on the internet.`,
  //   envoyezSigner: 'Send and sign',
  //   vosDocumentsEnLigne: 'your documents online.',
  //   OuQueVousSoyezEnTouteSimplicite: 'Wherever you are, with ease.',
  //   rapideFacileEtMoindreCout:
  //     'It’s fast, easy and cost-effective: try DKBSign now.',
  //   essayer: 'TRY',
  //   ilsNousFontConfiance: 'They put their trust in us.',
  //   signezSimplementVosDocumentsEnQuelquesClics:
  //     'Simply sign your documents in a few clicks!',
  //   telechargerVosDocuments: 'Upload your documents',
  //   designezLesSignataires:
  //     'Designate signers, location of signatures and send.',
  //   signezEtFaitesSigner: 'Sign and get signed',
  //   chaquesSignataireParEmailSignerSaisieCodeSMS:
  //     'Each signatory is invited by e-mail to sign by entering an SMS code.',
  //   conservezVosDocuments: 'Keep your documents',
  //   notreServiceDeConservationValeurProbanteSecurise:
  //     'Our probative service secures the storage of the signed document.',
  // },
  landingPage: {
    accueil: 'ACCUEIL',
    produits: 'PRODUITS',
    solutions: 'SOLUTIONS',
    api: 'API',
    token: 'TOKEN',
    plateform: 'PLATEFORM',
    tarif: 'TARIF',
    reference: 'REFERENCE',
    propos: 'A PROPOS',
    fr: 'FR',
    espaceClient: 'ESPACE CLIENT',
    connexion: 'CONNEXION',
    inscrivezVous: 'INSCRIVEZ-VOUS A LA NEWSLETTER',
    descriptionFooter: `DKBSign est une plateforme mise à la disposition des utilisateurs
    pour leur permettre de faire de la signature électronique afin de
    conférer une valeur juridique légale aux documents signés. DKBSign
    est un produit de DKB Solutions tiers de confiance agréé par
    l'ARTCI, engagé à garantir la sécurité, la confidentialité,
    l'intégrité des transactions sur internet`,
    envoyezSigner: 'Envoyez et signez',
    vosDocumentsEnLigne: 'vos documents en ligne.',
    OuQueVousSoyezEnTouteSimplicite: 'Où que vous soyez, en toute simplicité.',
    rapideFacileEtMoindreCout:
      'C’est rapide, facile et à moindre cout : essayez DKBSign dès maintenant.',
    essayer: 'ESSAYER',
    ilsNousFontConfiance: 'Ils nous font confiance.',
    signezSimplementVosDocumentsEnQuelquesClics:
      'Signez simplement vos documents en quelques clics !',
    telechargerVosDocuments: 'Télécharger vos documents',
    designezLesSignataires: `Désignez les signataires, l'emplacement des signatures et envoyez.`,
    signezEtFaitesSigner: 'Signez et faites signer',
    chaquesSignataireParEmailSignerSaisieCodeSMS: `Chaques signataire est invité par e-mail a signer grâce a la saisie d'un code SMS.`,
    conservezVosDocuments: 'Conservez vos documents',
    notreServiceDeConservationValeurProbanteSecurise:
      'Notre service de conservation a valeur probante sécurise le stockage du document signé.',
  },
  others: {
    actualites: 'News',
  },
  admin: {
    tableauDeBord: 'Dashboard',
    boiteDeReception: 'Inbox',
    mesDocuments: 'My documents',
    rapport: 'Report',
    contact: 'contact',
    signatureRestante: 'Remaining signature',
    signaturesRestantes: 'Remainings signatures',
    documentsTotal: 'Total documents',
    contactEnregistre: 'Recorded contact',
    documentsSigneAujourd: 'Documents signed today',
    statistiqueDesDocuments: 'Statistics document',
    CourbeDesDocumentsEnFonctionsDesStatus:
      'Curve of documents according to the status',
    signer: 'Sign',
    seulSignataire: 'Only signatory',
    faireSigner: 'Get signed',
    signerFaireSigner: 'Sign & Get Signed',
    documentsSignes: 'Signed documents',
    documentsRefuses: 'Refused documents',
    documentsEnAttentes: 'Documents pending',
    refuse: 'Refused',
    signe: 'Signed',
    attente: 'Pending',
    encours: 'In progress',
    vosDocuments: 'Your documents',
    voirTout: 'See all',
    documentSigne: 'Signed document',
    documentsEnAttente: 'Pending documents',
    DocumentsEnCours: 'Documents in progress',
    DocumentsRefuse: 'Documents refused',
    signezVosDocuments: 'Sign your PDF documents',
    chargezVosDocuments: 'Upload your PDF documents',
    signature: 'Signature',
    definissezVotreSignature: 'Set your signature',
    chargezVosDocumentsIci: 'Upload your PDF documents here',
    chargement: 'Loading',
    suivant: 'Next',
    terminer: 'Finish',
    termine: 'Done',
    vousPerdrezToutesModificationsEffectues:
      'If you close the window, you will lose all the changes made.',
    dataMonth: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    rechercherUnDocument: 'Search for a document',
    nom: 'Name',
    entrezLeNom: 'Enter first name',
    prenom: 'Last name',
    entrezLePrenom: 'Enter last name',
    telephone: 'Tel',
    email: 'Email',
    entrezEmail: `Enter Email`,
    entrezVotreContacts: 'Enter contact',
    motif: 'Motive',
    rechercherUnContact: 'Search for a contact',
    rechercherUnUtilisateur: 'Search for a user',
    rechercherUneEntreprise: 'Search for a company',
    rechercherUnCertificat: 'Search for a certificate',
    tous: 'All',
    recu: 'Received',
    appliquerLeFiltre: 'Apply the filter',
    voirLeDocument: 'View document',
    importerContact: 'Import contact',
    ajouterContact: 'Add contact',
    modifierContact: 'Edit contact',
    utilisateur: 'User',
    fonction: 'Function',
    entreprise: 'Enterprise',
    role: 'Role',
    datenscription: `Registration date`,
    souvenirDeMoi: 'Remember me',
    connect: 'Sign in',
    attention: 'Warning',
    listeDocumentsCharges: 'List of loaded documents',
    precedent: 'previous',
    deinition: 'Definition',
    chargerUneImage: 'Load an image',
    zoneDeSignature: 'Signature area',
    paraphe: 'Initial',
    effacer: 'Clear',
    codeAuthentification: `Authentication code`,
    ajoutezVosSignataires: 'Add your signers',
    signataires: 'Signatories',
    fullName: 'Full name',
    ajouter: 'Add',
    cliquezPourSigne: 'Select to sign',
    votreQrcode: 'Your qrcode',
    signataire: 'Signatory',
    outils: 'Tools',
    sur: 'on',
    cliquezSurLeBouton: `Select the location where your signature will appear.`,
    selectionDeSignature: 'Signature selection',
    fermer: 'Close',
    selectionner: 'Select',
    enSignantDocumentAttesteAvoirLuComprisEtAcceptLes: `By signing this document, I certify that I have read, understood and accepted the`,
    conditionsRelativesSignatureElectronique:
      'conditions relating to the electronic signature',
    leDocument: 'The document',
    nApasEteSigne: `has not been signed`,
    nOntPasEteCorrectementRenseignes: `have not been filled in correctly`,
    etreVousSurAvoirLu: `Are you sure you have read the entire previous document(s)?`,
    oui: 'Ok',
    non: 'No',
    info: 'Infos',
    voir: 'View',
    annuler: 'Close',
    soumettre: 'Submit',
    chargerVosContact: 'Load your contacts',
    valider: 'validate',
    actualiteEteAjoute: `The news has been added`,
    erreurImpossibleAjouterActualite: 'Error, cannot add news',
    actualiteEteModifie: `The news has been changed`,
    erreurImpossibleDeModifieActualite: `Error, unable to change the news`,
    actualitéEteSupprime: `The news has been deleted`,
    erreurImpossibleDeSupprimerActualite: `Error, cannot delete news`,

    imageEteAjouteAvecSucces: `The image has been successfully added`,
    erreurImpossibleAjouterImage: `Cannot add image error`,
    imageAEteModifie: `The image has been modified`,
    erreurImpossibleDeModifieImage: `Cannot edit image error`,
    lesImagesOntEteSupprime: `The images have been deleted`,
    erreurImpossibleDeSupprimerLesImages: `Cannot delete image error`,
    emailOuMotDePasseIncorrect: `Incorrect email or password`,

    veuillezSaisirToutLesChamps: 'Please enter all fields',
    leMotDasseDoitContenirAuMinimumCaracteres:
      'The password must contain at least 8 characters',
    votreDocumentEstEnCoursDeSignature: 'Your document is being signed',
  },
};
